import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import { RiSendPlaneLine } from "react-icons/ri";
import { TiEdit } from "react-icons/ti";
import { IoTrashOutline } from "react-icons/io5";
import { BsThreeDots } from "react-icons/bs";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { HiOutlineArrowRight } from "react-icons/hi";
import { AiOutlineEye } from "react-icons/ai";

// Example items, to simulate fetching from another resources.

function Items({
  setOpenDeleteAnalysis,
  setOpenShowAnalysis,
  setOpenEditAnalysis,
  currentItems,
  setSelectedTestId,
}) {
  return (
    <>
      {currentItems &&
        currentItems.map((item) => (
          <tr className="border-b-[1px] ">
            <td className="w-fit">
              <input
                name="check"
                type="checkbox"
                className="text-[#E4E7EC] border-[#E4E7EC] border-[1px] ml-5 w-fit"
              />
            </td>
            <td className="font-Poppins-Regular text-black text-base font-semibold py-6 ">
              <p>{item.TestName}</p>
            </td>
            <td className="font-Poppins-Regular text-black text-base font-semibold py-6 ">
              {item.publish_date}
            </td>
            <td className="font-Poppins-Regular text-black text-base font-semibold py-6 pl-2">
              {item.price}
            </td>
            <td className="font-Poppins-Regular text-black text-base font-semibold py-6 pl-2">
              {item.type}
            </td>
            <td>
              <div className="flex space-x-2 py-4 pr-5">
                <AiOutlineEye
                  className="text-2xl text-black cursor-pointer"
                  onClick={() => {
                    setOpenShowAnalysis(true)
                    setSelectedTestId(item.id)
                  }}
                />
                <TiEdit
                  className="text-2xl  opacity-50 cursor-pointer"
                  onClick={() => {
                    setOpenEditAnalysis(true)
                    setSelectedTestId(item.id)
                  }}
                />
                <IoTrashOutline
                  className="text-2xl text-[#F04438] cursor-pointer"
                  onClick={() => {
                    setOpenDeleteAnalysis(true)
                    setSelectedTestId(item.id)
                  }}
                />
              </div>
            </td>
          </tr>
        ))}
    </>
  );
}

function AnalysisDBPangration({
  setOpenDeleteAnalysis,
  setOpenShowAnalysis,
  setOpenEditAnalysis,
  section,
  itemsPerPage,
  Data,
  setSelectedTestId,
}) {
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = Data.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(Data.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % Data.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );

    setItemOffset(newOffset);
  };

  const Checkall = () => {
    if (document.getElementById("HeadCheck").checked) {
      let checks = document.getElementsByName("check");
      for (let i = 0; i <= checks.length; i++) {
        checks[i].checked = true;
      }
    } else if (!document.getElementById("HeadCheck").checked) {
      let checks = document.getElementsByName("check");
      for (let i = 0; i <= checks.length; i++) {
        checks[i].checked = false;
      }
    }
  };
  return (
    <div className={` overflow-x-scroll`}>
      <table className="w-full h-full mt-5 bg-white rounded-t-2xl ">
        <tr className="border-b-[1px] w-full">
          <td className="w-fit  pr-2 lg:pr-0">
            <input
              id="HeadCheck"
              type="checkbox"
              className="text-[#E4E7EC] border-[#E4E7EC] border-[1px] ml-5 "
              onClick={() => Checkall()}
            />
          </td>
          <td className="text-sm text-[#98A2B3] font-Poppins-Regular py-2  pr-20 lg:pr-0">
            Test name
          </td>
          <td className="text-sm text-[#98A2B3] font-Poppins-Regular py-2   pr-20 lg:pr-0">
            publish date
          </td>
          <td className="text-sm text-[#98A2B3] font-Poppins-Regular py-2 pl-2 pr-20 lg:pr-0">
            price
          </td>
          <td className="text-sm text-[#98A2B3] font-Poppins-Regular py-2  pr-20 lg:pr-0 ">
            test type
          </td>
          <td className="text-sm text-[#98A2B3] font-Poppins-Regular py-2 w-[8%] pr-20 lg:pr-0">
            Action
          </td>
        </tr>
        <Items
          setOpenDeleteAnalysis={setOpenDeleteAnalysis}
          setOpenShowAnalysis={setOpenShowAnalysis}
          setOpenEditAnalysis={setOpenEditAnalysis}
          currentItems={currentItems}
          className="w-full bg-white"
          setSelectedTestId={setSelectedTestId}
        />
      </table>

      <ReactPaginate
        breakLabel={<BsThreeDots />}
        nextLabel={
          <div className="bg-white py-[0.4rem] px-2  rounded-lg">
            <HiOutlineArrowRight className="bg-white text-xl" />
          </div>
        }
        onPageChange={handlePageClick}
        pageRangeDisplayed={1}
        pageCount={pageCount}
        previousLabel={
          <div className="bg-white py-[0.4rem] px-2  rounded-lg">
            <HiOutlineArrowLeft className="bg-white text-xl" />
          </div>
        }
        pageClassName="bg-white  font-Poppins-Regular py-1 px-3 rounded-lg"
        containerClassName="flex justify-center space-x-5 mb-2 border-gray-400 w-full  bottom-0   items-center mt-10"
        activeClassName="bg-[#B7C835] text-[#FFFFFF] "
        renderOnZeroPageCount={null}
      />
    </div>
  );
}
export default AnalysisDBPangration;
